export default __webpack_public_path__ + "media/react/gre/organisms/checkpoints/assets/full_practice_test_incomplete-23db1c29e0cfe157168ee13f5fc0990f.svg";